// React

// Components
import { Card, Collapse, Grid, Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import PropTypes from "prop-types";

// Data
import SoftBadge from "components/SoftBadge";
import dayjs from "dayjs";
import { useContext, useState } from "react";
import { getColor } from "utils/colors";
import ProfileCard from "../ProfileCard";
import { MenuContext } from "context/menuContext";
import ModalNuevoPermiso from "../NuevoPermiso";
import { gql, useQuery } from "@apollo/client";
import Loading from "components/Carteles/Loading";
import SinDatos from "components/Carteles/SinDatos";
import ModalComprobantePago from "../ComprobantePago";
import ModalMotivo from "../ModalRechazo";
import ModalPermisoPDF from "layouts/permisos-pesca/PermisoPDF";
import { GiDeerHead, GiPig, GiRabbit } from "react-icons/gi";
import ModalNuevoPermisoCaza from "../NuevoPermisoCaza";
import ModalComprobantesCaza from "../ComprobantesCaza";
import ModalPermisoCazaPDF from "layouts/permisos-caza/PermisoPDF";
import ModalPermisosCampo from "../ModalPermisoCampo";
import ModalPermisoAcompaniante from "../ModalPermisoAcompaniante";
import ModalGuia from "../ModalGuia";
import ModalGuiaPDF from "../GuiaPdf";

export default function Resumen({ usuario, carrera, loading, refetch, setTab }) {
  const [expanded, setExpanded] = useState([]);
  const [openNuevoPermiso, setOpenNuevoPermiso] = useState(false);
  const [openNuevoPermisoCaza, setOpenNuevoPermisoCaza] = useState(false);
  const [nuevoPermisoType, setNuevoPermisoType] = useState(null);
  const [idSelectedPermiso, setIdSelectedPermiso] = useState(null);
  const [openAddComprobantePago, setOpenAddComprobantePago] = useState(false);
  const [openComprobantesCaza, setOpenComprobantesCaza] = useState(false);
  const [openModalMotivo, setOpenModalMotivo] = useState(false);
  const [openModalPermisoPDF, setOpenModalPermisoPDF] = useState(false);
  const [openModalPermisoCazaPDF, setOpenModalPermisoCazaPDF] = useState(false);
  const [openModalPermisosCampo, setOpenModalPermisosCampo] = useState(false);
  const [openModalPermisoAcompaniante, setOpenModalPermisoAcompaniante] = useState(false);
  const [openModalGuia, setOpenModalGuia] = useState(false);
  const [openModalGuiaPDF, setOpenModalGuiaPDF] = useState(false);
  const [selectedGuia, setSelectedGuia] = useState(null);
  const { menu } = useContext(MenuContext);

  const {
    data: permisos,
    loading: loadingPermisos,
    refetch: refetchPermisos,
  } = useQuery(
    gql`
      query getPermisos {
        permisosGob {
          id
          tipo
          fechaVencimiento
          estado
          anioPermiso
          nroPermiso
        }
      }
    `,
    {
      fetchPolicy: "no-cache",
      cachePolicy: "no-cache",
    }
  );
  const {
    data: guias,
    loading: loadingGuias,
    refetch: refetchGuias,
  } = useQuery(
    gql`
      query getGuias {
        guiasTransito {
          id
          nroGuia
          originariosDe
          destino
          domicilioDestino
          medioTransporte
          fechaExpedicion
          estado
          anioGuia
          tiempoValidez
          createdAt
          url
          motivoRechazo
          comentario
          usuario {
            nombre
            apellido
            dni
          }
          detalles {
            id
            cantidad
            especie
            descripcion
          }
        }
      }
    `,
    {
      fetchPolicy: "no-cache",
      cachePolicy: "no-cache",
    }
  );

  return (
    <SoftBox>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3}>
          <ProfileCard
            usuario={usuario}
            estado={
              permisos?.permisosGob?.some(
                (permiso) =>
                  permiso.estado === "Aprobado" && dayjs(permiso.fechaVencimiento).isAfter(dayjs())
              )
                ? "Activo"
                : permisos?.permisosGob?.some((permiso) => permiso.estado === "En revisión")
                ? "En revisión"
                : permisos?.permisosGob?.some((permiso) => permiso.estado === "Rechazado")
                ? "Rechazado"
                : "Inactivo"
            }
            loading={loading}
            handleClick={() => setTab(2)}
          />
        </Grid>
        <Grid item xs={12} sm={9}>
          <Grid item xs={12} container spacing={2}>
            <Grid item xs={12}>
              <Card>
                <SoftBox p={2}>
                  <SoftBox
                    display="flex"
                    flexDirection={{
                      xs: "column",
                      sm: "row",
                    }}
                    justifyContent="space-between"
                    alignItems={{
                      xs: "flex-start",
                      sm: "center",
                    }}
                    gap={2}
                  >
                    <SoftBox display="flex" alignItems="center">
                      <SoftBox mr={1} display="flex" alignItems="center">
                        <SoftBox
                          display="grid"
                          justifyContent="center"
                          alignItems="center"
                          bgColor="primary"
                          color="white"
                          width="3rem"
                          height="3rem"
                          shadow="md"
                          borderRadius="lg"
                          variant="gradient"
                        >
                          <Icon fontSize="default">article</Icon>
                        </SoftBox>
                      </SoftBox>
                      <SoftBox
                        display="flex-row"
                        alignItems="center"
                        sx={{
                          lineHeight: 0,
                        }}
                      >
                        <SoftTypography variant="h6" fontWeight="bold">
                          Permisos de caza y pesca
                        </SoftTypography>
                        <SoftTypography variant="caption" fontWeight="regular">
                          {permisos?.permisosGob?.length
                            ? `${permisos?.permisosGob?.length} permisos generados`
                            : "No hay permisos generados"}
                        </SoftTypography>
                      </SoftBox>
                    </SoftBox>
                    <SoftBox
                      sx={{
                        width: {
                          xs: "100%",
                          sm: "auto",
                        },
                      }}
                    >
                      <Tooltip title="Nuevo permiso" placement="top">
                        <SoftButton
                          fullWidth
                          color="gobSecondary"
                          onClick={(event) => {
                            menu({
                              open: event.currentTarget,
                              align: "right",
                              options: [
                                {
                                  name: "Permiso de pesca anual",
                                  icon: {
                                    icon: "calendar_month",
                                    color: getColor("gobPrimary"),
                                  },
                                  onClick: () => {
                                    setNuevoPermisoType("anual");
                                    setOpenNuevoPermiso(true);
                                  },
                                },
                                {
                                  name: "Permiso de pesca diario",
                                  icon: {
                                    icon: "event",
                                    color: getColor("gobPrimary"),
                                  },
                                  onClick: () => {
                                    setNuevoPermisoType("diario");
                                    setOpenNuevoPermiso(true);
                                  },
                                },
                                {
                                  name: "Permiso de caza mayor",
                                  icon: {
                                    icon: <GiDeerHead />,
                                    color: getColor("gobSecondary"),
                                  },
                                  onClick: () => {
                                    setNuevoPermisoType("Permiso de caza mayor");
                                    setOpenNuevoPermisoCaza(true);
                                  },
                                },
                                {
                                  name: "Permiso de caza menor",
                                  icon: {
                                    icon: <GiRabbit />,
                                    color: getColor("gobSecondary"),
                                  },
                                  onClick: () => {
                                    setNuevoPermisoType("Permiso de caza menor");
                                    setOpenNuevoPermisoCaza(true);
                                  },
                                },
                                {
                                  name: "Permiso de caza mayor y menor",
                                  icon: {
                                    icon: <GiPig />,
                                    color: getColor("gobSecondary"),
                                  },
                                  onClick: () => {
                                    setNuevoPermisoType("Permiso de caza mayor y menor");
                                    setOpenNuevoPermisoCaza(true);
                                  },
                                },
                              ],
                              handleClose: () => {},
                            });
                          }}
                        >
                          <Icon>add</Icon>
                          &nbsp; Nuevo permiso
                        </SoftButton>
                      </Tooltip>
                    </SoftBox>
                  </SoftBox>
                  <SoftBox mt={2}>
                    <Card
                      sx={{
                        border: "1px solid rgba(0, 0, 0, 0.12)",
                      }}
                    >
                      <SoftBox
                        display="flex"
                        justifyContent="space-between"
                        px={2}
                        py={1}
                        sx={{
                          borderBottom: !expanded.includes("Historial de Permisos")
                            ? "none"
                            : "1px solid rgba(0, 0, 0, 0.12)",
                          cursor: "pointer",
                          "&:hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.04)",
                          },
                        }}
                        onClick={(e) => {
                          setExpanded(
                            expanded.includes("Historial de Permisos")
                              ? expanded.filter((i) => i !== "Historial de Permisos")
                              : [...expanded, "Historial de Permisos"]
                          );
                        }}
                      >
                        <SoftBox display="flex" alignItems="center">
                          <SoftBox mr={1} display="flex" alignItems="center">
                            <Icon
                              sx={{
                                color: getColor("gobSecondary"),
                              }}
                            >
                              history
                            </Icon>
                          </SoftBox>
                          <SoftTypography variant="h6" fontWeight="bold">
                            Historial de permisos
                          </SoftTypography>
                        </SoftBox>
                        <SoftBox display="flex" justifyContent="flex-end" alignItems="center">
                          <SoftBox>
                            <Tooltip
                              title={
                                expanded.includes("Historial de Permisos") ? "Ocultar" : "Mostrar"
                              }
                              placement="top"
                            >
                              <SoftButton
                                color="primary"
                                iconOnly
                                onClick={() =>
                                  setExpanded(
                                    expanded.includes("Historial de Permisos")
                                      ? expanded.filter((i) => i !== "Historial de Permisos")
                                      : [...expanded, "Historial de Permisos"]
                                  )
                                }
                              >
                                <Icon
                                  sx={{
                                    rotate: expanded.includes("Historial de Permisos")
                                      ? "180deg"
                                      : "0deg",
                                    transition: "all 0.5s",
                                  }}
                                >
                                  expand_more
                                </Icon>
                              </SoftButton>
                            </Tooltip>
                          </SoftBox>
                        </SoftBox>
                      </SoftBox>
                      <Collapse in={expanded.includes("Historial de Permisos")}>
                        {loading || loadingPermisos ? (
                          <Loading />
                        ) : permisos?.permisosGob?.length ? (
                          permisos?.permisosGob?.map((permiso, index) => (
                            <SoftBox key={permiso.id}>
                              <SoftBox
                                px={2}
                                py={1}
                                sx={{
                                  borderBottom:
                                    index === permisos?.permisosGob?.length - 1
                                      ? "none"
                                      : "1px solid rgba(0, 0, 0, 0.12)",
                                  cursor: "pointer",
                                  "&:hover": {
                                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                                  },
                                }}
                              >
                                <SoftBox display="flex" justifyContent="space-between">
                                  <SoftBox
                                    display="flex"
                                    alignItems="center"
                                    pl={{
                                      xs: 0,
                                      sm: 2,
                                    }}
                                  >
                                    <SoftBox
                                      mr={1}
                                      sx={{
                                        display: {
                                          xs: "none",
                                          sm: "block",
                                        },
                                      }}
                                    >
                                      <Icon
                                        sx={{
                                          color: getColor("gobPrimary"),
                                        }}
                                      >
                                        subdirectory_arrow_right
                                      </Icon>
                                    </SoftBox>
                                    <SoftBox
                                      mr={1}
                                      sx={{
                                        display: {
                                          xs: "none",
                                          sm: "flex",
                                        },
                                      }}
                                    >
                                      <Tooltip title={permiso.tipo} placement="top">
                                        <Icon
                                          sx={{
                                            color: getColor("gobSecondary"),
                                          }}
                                        >
                                          {permiso.tipo === "Permiso de pesca anual" ? (
                                            "calendar_month"
                                          ) : permiso.tipo === "Permiso de pesca diario" ? (
                                            "event"
                                          ) : permiso.tipo === "Permiso de caza mayor" ? (
                                            <GiDeerHead />
                                          ) : permiso.tipo === "Permiso de caza menor" ? (
                                            <GiRabbit />
                                          ) : permiso.tipo === "Permiso de caza mayor y menor" ? (
                                            <GiPig />
                                          ) : (
                                            "group"
                                          )}
                                        </Icon>
                                      </Tooltip>
                                    </SoftBox>
                                    <SoftBox display="flex" flexDirection="column">
                                      <SoftTypography variant="h6">
                                        {`${permiso.tipo} Nº${permiso.anioPermiso} - ${permiso.nroPermiso}`}
                                        &nbsp;&nbsp;
                                        <SoftBadge
                                          color={
                                            dayjs(permiso.fechaVencimiento).isBefore(dayjs())
                                              ? "error"
                                              : permiso.estado === "Aprobado"
                                              ? "success"
                                              : permiso.estado === "Rechazado"
                                              ? "error"
                                              : permiso.estado === "En revisión"
                                              ? "gobSecondary"
                                              : "primary"
                                          }
                                          badgeContent={
                                            dayjs(permiso.fechaVencimiento).isBefore(dayjs())
                                              ? "Vencido"
                                              : permiso.estado
                                          }
                                        />
                                      </SoftTypography>
                                      <SoftTypography variant="caption" fontWeight="regular">
                                        {` Válido hasta ${dayjs(permiso.fechaVencimiento).format(
                                          "DD/MM/YYYY"
                                        )}`}
                                      </SoftTypography>
                                    </SoftBox>
                                  </SoftBox>
                                  <SoftBox
                                    display="flex"
                                    justifyContent="flex-end"
                                    alignItems="center"
                                    gap={2}
                                    flexDirection={{
                                      xs: "column",
                                      // sm: "column",
                                      xl: "row",
                                    }}
                                  >
                                    {permiso.estado === "Pendiente de pago" && (
                                      <SoftBox>
                                        <Tooltip title={"Subir comprobante"} placement="top">
                                          <SoftButton
                                            color={"gobSecondary"}
                                            onClick={() => {
                                              setIdSelectedPermiso(permiso.id);
                                              if (
                                                permiso.tipo === "Permiso de pesca anual" ||
                                                permiso.tipo === "Permiso de pesca diario"
                                              ) {
                                                setOpenAddComprobantePago(true);
                                              } else {
                                                setOpenComprobantesCaza(true);
                                              }
                                            }}
                                            disabled={dayjs(permiso.fechaVencimiento).isBefore(
                                              dayjs()
                                            )}
                                            sx={{
                                              display: {
                                                xs: "none",
                                                sm: "flex",
                                              },
                                            }}
                                          >
                                            Subir comprobante&nbsp;
                                            <Icon>upload</Icon>
                                          </SoftButton>
                                        </Tooltip>
                                        <Tooltip title={"Subir comprobante"} placement="top">
                                          <SoftButton
                                            color={"gobSecondary"}
                                            iconOnly
                                            onClick={() => {
                                              setIdSelectedPermiso(permiso.id);
                                              if (
                                                permiso.tipo === "Permiso de pesca anual" ||
                                                permiso.tipo === "Permiso de pesca diario"
                                              ) {
                                                setOpenAddComprobantePago(true);
                                              } else {
                                                setOpenComprobantesCaza(true);
                                              }
                                            }}
                                            disabled={dayjs(permiso.fechaVencimiento).isBefore(
                                              dayjs()
                                            )}
                                            sx={{
                                              display: {
                                                xs: "flex",
                                                sm: "none",
                                              },
                                            }}
                                          >
                                            <Icon>upload</Icon>
                                          </SoftButton>
                                        </Tooltip>
                                      </SoftBox>
                                    )}
                                    {permiso.estado === "Rechazado" && (
                                      <SoftBox>
                                        <Tooltip title="Ver motivo de rechazo" placement="top">
                                          <SoftButton
                                            color="primary"
                                            onClick={() => {
                                              setIdSelectedPermiso(permiso.id);
                                              setOpenModalMotivo(true);
                                            }}
                                            sx={{
                                              display: {
                                                xs: "none",
                                                sm: "flex",
                                              },
                                            }}
                                          >
                                            Ver motivo de rechazo&nbsp;
                                            <Icon>error</Icon>
                                          </SoftButton>
                                        </Tooltip>
                                        <Tooltip title="Ver motivo de rechazo" placement="top">
                                          <SoftButton
                                            color="primary"
                                            iconOnly
                                            onClick={() => {
                                              setIdSelectedPermiso(permiso.id);
                                              setOpenModalMotivo(true);
                                            }}
                                            sx={{
                                              display: {
                                                xs: "flex",
                                                sm: "none",
                                              },
                                            }}
                                          >
                                            <Icon>error</Icon>
                                          </SoftButton>
                                        </Tooltip>
                                      </SoftBox>
                                    )}
                                    {permiso.estado === "Aprobado" &&
                                      permiso.tipo?.includes("caza") && (
                                        <SoftBox>
                                          <Tooltip title="Ver permisos de campo" placement="top">
                                            <SoftButton
                                              color="primary"
                                              onClick={() => {
                                                setIdSelectedPermiso(permiso.id);
                                                setOpenModalPermisosCampo(true);
                                              }}
                                              sx={{
                                                display: {
                                                  xs: "none",
                                                  sm: "flex",
                                                },
                                              }}
                                            >
                                              Ver permisos de campo&nbsp;
                                              <Icon>file_present</Icon>
                                            </SoftButton>
                                          </Tooltip>
                                          <Tooltip title="Ver permisos de campo" placement="top">
                                            <SoftButton
                                              color="primary"
                                              iconOnly
                                              onClick={() => {
                                                setIdSelectedPermiso(permiso.id);
                                                setOpenModalPermisosCampo(true);
                                              }}
                                              sx={{
                                                display: {
                                                  xs: "flex",
                                                  sm: "none",
                                                },
                                              }}
                                            >
                                              <Icon>file_present</Icon>
                                            </SoftButton>
                                          </Tooltip>
                                        </SoftBox>
                                      )}
                                    {permiso.estado === "Aprobado" && (
                                      <SoftBox>
                                        <Tooltip title="Ver PDF" placement="top">
                                          <SoftButton
                                            color="success"
                                            onClick={() => {
                                              setIdSelectedPermiso(permiso.id);
                                              permiso.tipo?.includes("caza")
                                                ? setOpenModalPermisoCazaPDF(true)
                                                : setOpenModalPermisoPDF(true);
                                            }}
                                            sx={{
                                              display: {
                                                xs: "none",
                                                sm: "flex",
                                              },
                                            }}
                                          >
                                            Ver permiso&nbsp;
                                            <Icon>file_open</Icon>
                                          </SoftButton>
                                        </Tooltip>
                                        <Tooltip title="Ver PDF" placement="top">
                                          <SoftButton
                                            color="success"
                                            iconOnly
                                            onClick={() => {
                                              setIdSelectedPermiso(permiso.id);
                                              permiso.tipo?.includes("caza")
                                                ? setOpenModalPermisoCazaPDF(true)
                                                : setOpenModalPermisoPDF(true);
                                            }}
                                            sx={{
                                              display: {
                                                xs: "flex",
                                                sm: "none",
                                              },
                                            }}
                                          >
                                            <Icon>file_open</Icon>
                                          </SoftButton>
                                        </Tooltip>
                                      </SoftBox>
                                    )}
                                    {permiso.estado === "Aprobado" &&
                                      permiso.tipo?.includes("caza") && (
                                        <SoftBox>
                                          <Tooltip title="Permiso acompañante" placement="top">
                                            <SoftButton
                                              color="gobSecondary"
                                              onClick={() => {
                                                setIdSelectedPermiso(permiso.id);
                                                setOpenModalPermisoAcompaniante(true);
                                              }}
                                              disabled={dayjs(permiso.fechaVencimiento).isBefore(
                                                dayjs()
                                              )}
                                              sx={{
                                                display: {
                                                  xs: "none",
                                                  sm: "flex",
                                                },
                                              }}
                                            >
                                              Permiso acompañante&nbsp;
                                              <Icon>people_alt</Icon>
                                            </SoftButton>
                                          </Tooltip>
                                          <Tooltip title="Permiso acompañante" placement="top">
                                            <SoftButton
                                              color="gobSecondary"
                                              onClick={() => {
                                                setIdSelectedPermiso(permiso.id);
                                                setOpenModalPermisoAcompaniante(true);
                                              }}
                                              iconOnly
                                              disabled={dayjs(permiso.fechaVencimiento).isBefore(
                                                dayjs()
                                              )}
                                              sx={{
                                                display: {
                                                  xs: "flex",
                                                  sm: "none",
                                                },
                                              }}
                                            >
                                              <Icon>people_alt</Icon>
                                            </SoftButton>
                                          </Tooltip>
                                        </SoftBox>
                                      )}
                                    {permiso.estado === "En revisión" &&
                                      permiso.tipo === "Permiso de pesca anual" && (
                                        <SoftBox>
                                          <Tooltip title="Ver Permiso Temporal" placement="top">
                                            <SoftButton
                                              color="gobSecondary"
                                              onClick={() => {
                                                setIdSelectedPermiso(permiso.id);
                                                setOpenModalPermisoPDF(true);
                                              }}
                                              disabled={dayjs(permiso.fechaVencimiento).isBefore(
                                                dayjs()
                                              )}
                                              sx={{
                                                display: {
                                                  xs: "none",
                                                  sm: "flex",
                                                },
                                              }}
                                            >
                                              Ver permiso temporal&nbsp;
                                              <Icon>file_open</Icon>
                                            </SoftButton>
                                          </Tooltip>
                                          <Tooltip title="Ver Permiso Temporal" placement="top">
                                            <SoftButton
                                              color="gobSecondary"
                                              onClick={() => {
                                                setIdSelectedPermiso(permiso.id);
                                                setOpenModalPermisoPDF(true);
                                              }}
                                              iconOnly
                                              disabled={dayjs(permiso.fechaVencimiento).isBefore(
                                                dayjs()
                                              )}
                                              sx={{
                                                display: {
                                                  xs: "flex",
                                                  sm: "none",
                                                },
                                              }}
                                            >
                                              <Icon>file_open</Icon>
                                            </SoftButton>
                                          </Tooltip>
                                        </SoftBox>
                                      )}
                                  </SoftBox>
                                </SoftBox>
                              </SoftBox>
                            </SoftBox>
                          ))
                        ) : (
                          <SinDatos />
                        )}
                      </Collapse>
                    </Card>
                  </SoftBox>
                </SoftBox>
              </Card>
              <Card>
                <SoftBox p={2}>
                  <SoftBox
                    display="flex"
                    flexDirection={{
                      xs: "column",
                      sm: "row",
                    }}
                    justifyContent="space-between"
                    alignItems={{
                      xs: "flex-start",
                      sm: "center",
                    }}
                    gap={2}
                  >
                    <SoftBox display="flex" alignItems="center">
                      <SoftBox mr={1} display="flex" alignItems="center">
                        <SoftBox
                          display="grid"
                          justifyContent="center"
                          alignItems="center"
                          bgColor="primary"
                          color="white"
                          width="3rem"
                          height="3rem"
                          shadow="md"
                          borderRadius="lg"
                          variant="gradient"
                        >
                          <Icon fontSize="default">local_shipping</Icon>
                        </SoftBox>
                      </SoftBox>
                      <SoftBox
                        display="flex-row"
                        alignItems="center"
                        sx={{
                          lineHeight: 0,
                        }}
                      >
                        <SoftTypography variant="h6" fontWeight="bold">
                          Guías de tránsito
                        </SoftTypography>
                        <SoftTypography variant="caption" fontWeight="regular">
                          {guias?.guiasTransito?.length
                            ? `${guias?.guiasTransito?.length} guías generadas`
                            : "No hay guías generadas"}
                        </SoftTypography>
                      </SoftBox>
                    </SoftBox>
                    <SoftBox
                      sx={{
                        width: {
                          xs: "100%",
                          sm: "auto",
                        },
                      }}
                    >
                      <Tooltip title="Nueva guía" placement="top">
                        <SoftButton
                          fullWidth
                          color="gobSecondary"
                          onClick={() => {
                            setOpenModalGuia(true);
                            setSelectedGuia(null);
                          }}
                        >
                          <Icon>add</Icon>
                          &nbsp; Nueva guía
                        </SoftButton>
                      </Tooltip>
                    </SoftBox>
                  </SoftBox>
                  <SoftBox mt={2}>
                    <Card
                      sx={{
                        border: "1px solid rgba(0, 0, 0, 0.12)",
                      }}
                    >
                      <SoftBox
                        display="flex"
                        justifyContent="space-between"
                        px={2}
                        py={1}
                        sx={{
                          borderBottom: !expanded.includes("Historial de Guías")
                            ? "none"
                            : "1px solid rgba(0, 0, 0, 0.12)",
                          cursor: "pointer",
                          "&:hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.04)",
                          },
                        }}
                        onClick={(e) => {
                          setExpanded(
                            expanded.includes("Historial de Guías")
                              ? expanded.filter((i) => i !== "Historial de Guías")
                              : [...expanded, "Historial de Guías"]
                          );
                        }}
                      >
                        <SoftBox display="flex" alignItems="center">
                          <SoftBox mr={1} display="flex" alignItems="center">
                            <Icon
                              sx={{
                                color: getColor("gobSecondary"),
                              }}
                            >
                              history
                            </Icon>
                          </SoftBox>
                          <SoftTypography variant="h6" fontWeight="bold">
                            Historial de guías
                          </SoftTypography>
                        </SoftBox>
                        <SoftBox display="flex" justifyContent="flex-end" alignItems="center">
                          <SoftBox>
                            <Tooltip
                              title={
                                expanded.includes("Historial de Guías") ? "Ocultar" : "Mostrar"
                              }
                              placement="top"
                            >
                              <SoftButton
                                color="primary"
                                iconOnly
                                onClick={() =>
                                  setExpanded(
                                    expanded.includes("Historial de Guías")
                                      ? expanded.filter((i) => i !== "Historial de Guías")
                                      : [...expanded, "Historial de Guías"]
                                  )
                                }
                              >
                                <Icon
                                  sx={{
                                    rotate: expanded.includes("Historial de Guías")
                                      ? "180deg"
                                      : "0deg",
                                    transition: "all 0.5s",
                                  }}
                                >
                                  expand_more
                                </Icon>
                              </SoftButton>
                            </Tooltip>
                          </SoftBox>
                        </SoftBox>
                      </SoftBox>
                      <Collapse in={expanded.includes("Historial de Guías")}>
                        {loading || loadingGuias ? (
                          <Loading />
                        ) : guias?.guiasTransito?.length ? (
                          guias?.guiasTransito?.map((permiso, index) => (
                            <SoftBox key={permiso.id}>
                              <SoftBox
                                px={2}
                                py={1}
                                sx={{
                                  borderBottom:
                                    index === guias?.guiasTransito?.length - 1
                                      ? "none"
                                      : "1px solid rgba(0, 0, 0, 0.12)",
                                  cursor: "pointer",
                                  "&:hover": {
                                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                                  },
                                }}
                              >
                                <SoftBox display="flex" justifyContent="space-between">
                                  <SoftBox
                                    display="flex"
                                    alignItems="center"
                                    pl={{
                                      xs: 0,
                                      sm: 2,
                                    }}
                                  >
                                    <SoftBox
                                      mr={1}
                                      sx={{
                                        display: {
                                          xs: "none",
                                          sm: "block",
                                        },
                                      }}
                                    >
                                      <Icon
                                        sx={{
                                          color: getColor("gobPrimary"),
                                        }}
                                      >
                                        subdirectory_arrow_right
                                      </Icon>
                                    </SoftBox>
                                    <SoftBox
                                      mr={1}
                                      sx={{
                                        display: {
                                          xs: "none",
                                          sm: "flex",
                                        },
                                      }}
                                    >
                                      <Icon
                                        sx={{
                                          color: getColor("gobSecondary"),
                                        }}
                                      >
                                        group
                                      </Icon>
                                    </SoftBox>
                                    <SoftBox display="flex" flexDirection="column">
                                      <SoftTypography variant="h6">
                                        {`Guía de tránsito ${
                                          permiso.nroGuia
                                            ? ` Nº ${permiso.anioGuia} - ${permiso.nroGuia}`
                                            : ` - Solicitado el ${dayjs(permiso.createdAt).format(
                                                "DD/MM/YYYY"
                                              )}`
                                        }`}
                                        &nbsp;&nbsp;
                                        <SoftBadge
                                          color={
                                            permiso.estado === "Aprobado"
                                              ? "success"
                                              : permiso.estado === "Rechazado"
                                              ? "error"
                                              : permiso.estado === "En revisión"
                                              ? "gobSecondary"
                                              : "primary"
                                          }
                                          badgeContent={
                                            dayjs(permiso.fechaVencimiento).isBefore(dayjs())
                                              ? "Vencido"
                                              : permiso.estado
                                          }
                                        />
                                      </SoftTypography>
                                      {permiso.estado == "Aprobado" && (
                                        <SoftTypography variant="caption" fontWeight="regular">
                                          {`Expedido ${dayjs(permiso.fechaExpedicion).format(
                                            "DD/MM/YYYY"
                                          )} - válido por ${permiso.tiempoValidez} horas`}
                                        </SoftTypography>
                                      )}
                                    </SoftBox>
                                  </SoftBox>
                                  <SoftBox
                                    display="flex"
                                    justifyContent="flex-end"
                                    alignItems="center"
                                    gap={2}
                                    flexDirection={{
                                      xs: "column",
                                      // sm: "column",
                                      xl: "row",
                                    }}
                                  >
                                    {permiso.estado === "Pendiente de pago" && (
                                      <SoftBox>
                                        <Tooltip title={"Subir comprobante"} placement="top">
                                          <SoftButton
                                            color={"gobSecondary"}
                                            onClick={() => {
                                              setIdSelectedPermiso(permiso.id);
                                              if (
                                                permiso.tipo === "Permiso de pesca anual" ||
                                                permiso.tipo === "Permiso de pesca diario"
                                              ) {
                                                setOpenAddComprobantePago(true);
                                              } else {
                                                setOpenComprobantesCaza(true);
                                              }
                                            }}
                                            disabled={dayjs(permiso.fechaVencimiento).isBefore(
                                              dayjs()
                                            )}
                                            sx={{
                                              display: {
                                                xs: "none",
                                                sm: "flex",
                                              },
                                            }}
                                          >
                                            Subir comprobante&nbsp;
                                            <Icon>upload</Icon>
                                          </SoftButton>
                                        </Tooltip>
                                        <Tooltip title={"Subir comprobante"} placement="top">
                                          <SoftButton
                                            color={"gobSecondary"}
                                            iconOnly
                                            onClick={() => {
                                              setIdSelectedPermiso(permiso.id);
                                            }}
                                            disabled={dayjs(permiso.fechaVencimiento).isBefore(
                                              dayjs()
                                            )}
                                            sx={{
                                              display: {
                                                xs: "flex",
                                                sm: "none",
                                              },
                                            }}
                                          >
                                            <Icon>upload</Icon>
                                          </SoftButton>
                                        </Tooltip>
                                      </SoftBox>
                                    )}
                                    {permiso.estado === "Aprobado" && (
                                      <SoftBox>
                                        <Tooltip title={"Descargar PDF"} placement="top">
                                          <SoftButton
                                            color={"gobPrimary"}
                                            onClick={() => {
                                              setIdSelectedPermiso(permiso.id);
                                              setOpenModalGuiaPDF(true);
                                              setSelectedGuia(permiso);
                                            }}
                                            sx={{
                                              display: {
                                                xs: "none",
                                                sm: "flex",
                                              },
                                            }}
                                          >
                                            Descargar PDF&nbsp;
                                            <Icon>download</Icon>
                                          </SoftButton>
                                        </Tooltip>
                                        <Tooltip title={"Descargar PDF"} placement="top">
                                          <SoftButton
                                            color={"gobPrimary"}
                                            iconOnly
                                            onClick={() => {
                                              setIdSelectedPermiso(permiso.id);
                                              setOpenModalGuiaPDF(true);
                                              setSelectedGuia(permiso);
                                            }}
                                            sx={{
                                              display: {
                                                xs: "flex",
                                                sm: "none",
                                              },
                                            }}
                                          >
                                            <Icon>download</Icon>
                                          </SoftButton>
                                        </Tooltip>
                                      </SoftBox>
                                    )}
                                  </SoftBox>
                                </SoftBox>
                              </SoftBox>
                            </SoftBox>
                          ))
                        ) : (
                          <SinDatos />
                        )}
                      </Collapse>
                    </Card>
                  </SoftBox>
                </SoftBox>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <ModalNuevoPermiso
        open={openNuevoPermiso}
        handleClose={() => {
          setOpenNuevoPermiso(false);
          setNuevoPermisoType(null);
        }}
        type={nuevoPermisoType}
        handleFinish={(id) => {
          setIdSelectedPermiso(id);
          refetchPermisos();
          setOpenAddComprobantePago(true);
        }}
      />
      <ModalNuevoPermisoCaza
        open={openNuevoPermisoCaza}
        handleClose={() => {
          setOpenNuevoPermisoCaza(false);
          setNuevoPermisoType(null);
        }}
        type={nuevoPermisoType}
        handleFinish={(id) => {
          setIdSelectedPermiso(id);
          refetchPermisos();
          setOpenComprobantesCaza(true);
        }}
      />
      <ModalComprobantePago
        open={openAddComprobantePago}
        handleClose={() => setOpenAddComprobantePago(false)}
        idPermiso={idSelectedPermiso}
        refetch={refetchPermisos}
      />
      <ModalComprobantesCaza
        open={openComprobantesCaza}
        handleClose={() => setOpenComprobantesCaza(false)}
        idPermiso={idSelectedPermiso}
        refetch={refetchPermisos}
      />
      <ModalMotivo
        open={openModalMotivo}
        handleClose={() => setOpenModalMotivo(false)}
        idPermiso={idSelectedPermiso}
      />
      <ModalPermisoPDF
        open={openModalPermisoPDF}
        handleClose={() => setOpenModalPermisoPDF(false)}
        idPermiso={idSelectedPermiso}
      />
      <ModalPermisoCazaPDF
        open={openModalPermisoCazaPDF}
        handleClose={() => setOpenModalPermisoCazaPDF(false)}
        idPermiso={idSelectedPermiso}
      />
      <ModalPermisosCampo
        open={openModalPermisosCampo}
        handleClose={() => setOpenModalPermisosCampo(false)}
        idPermiso={idSelectedPermiso}
      />
      <ModalPermisoAcompaniante
        open={openModalPermisoAcompaniante}
        handleClose={() => setOpenModalPermisoAcompaniante(false)}
        idPermiso={idSelectedPermiso}
      />
      <ModalGuia
        open={openModalGuia}
        handleClose={() => setOpenModalGuia(false)}
        selectedGuia={selectedGuia}
        refetch={refetchGuias}
      />
      <ModalGuiaPDF
        open={openModalGuiaPDF}
        handleClose={() => {
          setIdSelectedPermiso(null);
          setOpenModalGuiaPDF(false);
          setSelectedGuia(null);
        }}
        selectedGuia={selectedGuia}
        idPermiso={idSelectedPermiso}
      />
    </SoftBox>
  );
}

Resumen.propTypes = {
  usuario: PropTypes.object,
  carrera: PropTypes.object,
  loading: PropTypes.bool,
  refetch: PropTypes.func,
  setTab: PropTypes.func,
};
